// ============================================================
// FILTER FIX v5
// ============================================================

(function () {
  "use strict";

  var FILTER_PARAMS = [
    "filter.p.m.custom.material_tech",
    "filter.p.m.custom.feel",    
    "filter.p.m.custom.material",
    "filter.p.m.custom.season_warmth",
    "filter.p.m.custom.feel_texture",
    "filter.p.m.custom.use_case",
    "filter.p.m.custom.support_area",
    "filter.p.m.custom.size",
    "filter.p.m.custom.height",
    "filter.p.m.custom.mattress_accessories",
    "filter.v.availability",
    "filter.v.price.gte",
    "filter.v.price.lte",
  ];

  var RANGE_PARAMS = ["filter.v.price.gte", "filter.v.price.lte"];

  function isMobile() { return window.innerWidth < 750; }

  function debounce(fn, delay) {
    var timer;
    return function () {
      clearTimeout(timer);
      var args = arguments, ctx = this;
      timer = setTimeout(function () { fn.apply(ctx, args); }, delay);
    };
  }

  function triggerDesktopSubmit(swatchItem) {
    var desktopForm = document.getElementById("FacetFiltersForm");
    if (!desktopForm) return;
    var jsFilter = null;
    if (swatchItem) jsFilter = swatchItem.closest(".js-filter");
    if (!jsFilter) jsFilter = desktopForm.querySelector(".js-filter");
    if (!jsFilter) return;
    var triggerEl = jsFilter.querySelector(
      "input[type='checkbox']:not(.swatch-input__input):not(.facet-hidden-checkbox)"
    );
    if (!triggerEl) triggerEl = jsFilter.querySelector("input[type='text'], summary");
    if (!triggerEl) triggerEl = jsFilter;
    triggerEl.dispatchEvent(new Event("input", { bubbles: true }));
  }

  function syncSwatchCheckboxes(container) {
    if (!container) return;
    container.querySelectorAll(".facet-icon-item").forEach(function (item) {
      if (item._swatchSynced) return;
      item._swatchSynced = true;
      var hiddenCb = item.querySelector(".facet-hidden-checkbox");
      var swatchCb = item.querySelector(".swatch-input__input");
      var swatchLabel = item.querySelector(".swatch-input__label");
      if (!hiddenCb || !swatchCb) return;
      swatchCb.setAttribute("tabindex", "-1");
      swatchCb.style.pointerEvents = "none";
      
      // Prevent focus on mobile to avoid outline issues
      swatchCb.addEventListener("focus", function(e) {
        e.preventDefault();
        swatchCb.blur();
      });

      // Init: use hiddenCb as source of truth — sync swatchCb to match
      swatchCb.checked = hiddenCb.checked;

      if (swatchLabel) {
        swatchLabel.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (hiddenCb.disabled) return;
          hiddenCb.checked = !hiddenCb.checked;
          swatchCb.checked = hiddenCb.checked;
          updateSwatchStyle(item, hiddenCb.checked);
          if (isMobile()) { runDependencyUpdate(); return; }
          triggerDesktopSubmit(item);
          runDependencyUpdate();
        });
      }
      hiddenCb.addEventListener("change", function () {
        swatchCb.checked = hiddenCb.checked;
        updateSwatchStyle(item, hiddenCb.checked);
      });

      // Style based on hiddenCb only — not swatchCb
      updateSwatchStyle(item, hiddenCb.checked);
    });
  }

  function updateSwatchStyle(item, isChecked) {
    var swatchLabel = item.querySelector(".swatch-input__label");
    if (!swatchLabel) return;
    if (isChecked) {
      swatchLabel.style.outline = "1px solid #202020";
      swatchLabel.style.outlineOffset = "2px";
      swatchLabel.style.borderRadius = "50%";
    } else {
      swatchLabel.style.outline = "";
      swatchLabel.style.outlineOffset = "";
      swatchLabel.style.borderRadius = "";
    }
  }

  function applyFiltersFromURL() {
    var urlParams = new URLSearchParams(window.location.search);
    var applied = 0;
    FILTER_PARAMS.forEach(function (param) {
      if (RANGE_PARAMS.indexOf(param) !== -1) return;
      var values = urlParams.getAll(param);
      if (!values.length) return;
      values.forEach(function (val) {
        document.querySelectorAll('.facet-hidden-checkbox[name="' + param + '"]')
          .forEach(function (cb) {
            if (cb.value === val) {
              cb.checked = true;
              applied++;
              var parentItem = cb.closest(".facet-icon-item");
              if (parentItem) {
                var swatchCb = parentItem.querySelector(".swatch-input__input");
                if (swatchCb) swatchCb.checked = true;
                updateSwatchStyle(parentItem, true);
              }
            }
          });
        document.querySelectorAll('input[type="checkbox"][name="' + param + '"]')
          .forEach(function (cb) {
            if (cb.classList.contains("swatch-input__input")) return;
            if (cb.classList.contains("facet-hidden-checkbox")) return;
            if (cb.value === val) { cb.checked = true; applied++; }
          });
      });
    });
    if (applied > 0) setTimeout(runDependencyUpdate, 100);
  }

  var runDependencyUpdate = debounce(function () { _runDependencyUpdate(); }, 400);

  function _runDependencyUpdate() {
    var allSelections = collectAllSelections();
    var hasAny = Object.keys(allSelections).some(function (k) {
      return allSelections[k] && allSelections[k].length > 0;
    });
    if (!hasAny) { enableAllFilterItems(); return; }
    FILTER_PARAMS.forEach(function (targetParam) {
      if (RANGE_PARAMS.indexOf(targetParam) !== -1) return;
      var testParams = buildParamsExcluding(allSelections, targetParam);
      fetchFilterOptions(testParams, targetParam, function (available) {
        applyAvailability(targetParam, available);
      });
    });
  }

  function collectAllSelections() {
    var selections = {};
    [document.getElementById("FacetFiltersForm"), document.getElementById("FacetFiltersFormMobile")]
      .forEach(function (form) {
        if (!form) return;
        FILTER_PARAMS.forEach(function (param) {
          if (RANGE_PARAMS.indexOf(param) !== -1) return;
          form.querySelectorAll('input[name="' + param + '"]:checked').forEach(function (cb) {
            if (cb.classList.contains("swatch-input__input")) return;
            if (!selections[param]) selections[param] = [];
            if (selections[param].indexOf(cb.value) === -1) selections[param].push(cb.value);
          });
        });
      });
    return selections;
  }

  function buildParamsExcluding(selections, excludeParam) {
    var params = new URLSearchParams();
    Object.keys(selections).forEach(function (param) {
      if (param === excludeParam) return;
      selections[param].forEach(function (val) { params.append(param, val); });
    });
    var pg = document.getElementById("product-grid");
    if (pg && pg.dataset.id) params.set("section_id", pg.dataset.id);
    return params.toString();
  }

  function fetchFilterOptions(searchParams, targetParam, callback) {
    fetch(window.location.pathname + "?" + searchParams)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var available = new Set();
        doc.querySelectorAll('input[name="' + targetParam + '"]').forEach(function (input) {
          if (input.classList.contains("swatch-input__input")) return;
          var item = input.closest(".facets__item, li");
          if (!item) { available.add(input.value); return; }
          var match = (item.textContent || "").match(/\((\d+)\)/);
          if (match && parseInt(match[1]) > 0) available.add(input.value);
          else if (!match) available.add(input.value);
        });
        callback(available);
      })
      .catch(function () { callback(null); });
  }

  function applyAvailability(param, available) {
    if (!available) return;
    document.querySelectorAll('input[name="' + param + '"]').forEach(function (input) {
      if (input.classList.contains("swatch-input__input")) return;
      var item = input.closest(".facets__item, li");
      if (!item) return;
      available.has(input.value) ? enableFilterItem(input, item) : disableFilterItem(input, item);
    });
  }

  function disableFilterItem(input, item) {
    if (input.checked) {
      input.checked = false;
      var s = item.querySelector(".swatch-input__input");
      if (s) s.checked = false;
      updateSwatchStyle(item, false);
    }
    input.disabled = true;
    item.style.opacity = "0.3";
    item.style.pointerEvents = "none";
    var sl = item.querySelector(".swatch-input__label");
    if (sl) sl.style.pointerEvents = "none";
  }

  function enableFilterItem(input, item) {
    input.disabled = false;
    item.style.opacity = "";
    item.style.pointerEvents = "";
    var sl = item.querySelector(".swatch-input__label");
    if (sl) sl.style.pointerEvents = "";
  }

  function enableAllFilterItems() {
    FILTER_PARAMS.forEach(function (param) {
      if (RANGE_PARAMS.indexOf(param) !== -1) return;
      document.querySelectorAll('input[name="' + param + '"]').forEach(function (input) {
        if (input.classList.contains("swatch-input__input")) return;
        var item = input.closest(".facets__item, li");
        if (item) enableFilterItem(input, item);
      });
    });
  }

  function interceptMobileAutoSubmit() {
    var mobileForm = document.getElementById("FacetFiltersFormMobile");
    if (!mobileForm) return;
    ["input", "change"].forEach(function (evt) {
      mobileForm.addEventListener(evt, function (e) {
        if (isMobile()) e.stopImmediatePropagation();
        runDependencyUpdate();
      }, true);
    });
  }

  function setupMobileApplyButton() {
    var applyBtn = null;
    [
      ".mobile-facets__footer .facets__apply",
      ".mobile-facets__wrapper .facets__apply",
      ".mobile-facets .facets__apply",
    ].some(function (sel) { applyBtn = document.querySelector(sel); return !!applyBtn; });

    if (!applyBtn || applyBtn._applyBound) return;
    applyBtn._applyBound = true;
    applyBtn.removeAttribute("onclick");

    var resetBtn = document.querySelector(".mobile-facets__clear");
    if (resetBtn && !resetBtn._resetBound) {
      resetBtn._resetBound = true;

      resetBtn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        // 🔥 STEP 1: get current URL
        var url = new URL(window.location.href);

        // 🔥 STEP 2: preserve sort_by
        var sortValue = url.searchParams.get("sort_by");

        // 🔥 STEP 3: remove ONLY filter params
        FILTER_PARAMS.forEach(function (param) {
          url.searchParams.delete(param);
        });

        // 🔥 STEP 4: restore sort safely
        if (sortValue && sortValue.trim() !== "") {
          url.searchParams.set("sort_by", sortValue);
        }

        // 🔥 STEP 5: render page
        if (window.FacetFiltersForm) {
          FacetFiltersForm.renderPage(url.searchParams.toString(), null, true);
        }

        // 🔥 STEP 6: close drawer
        setTimeout(function () {
          var menuDrawer = document.querySelector("menu-drawer.mobile-facets__wrapper");
          if (menuDrawer) {
            if (typeof menuDrawer.closeAnimation === "function") menuDrawer.closeAnimation();
            else if (typeof menuDrawer.close === "function") menuDrawer.close();
            else {
              var details = menuDrawer.querySelector("details[open]");
              if (details) details.removeAttribute("open");
            }
          }

          document.documentElement.classList.remove("overflow-hidden");
          document.body.classList.remove("overflow-hidden");
          document.body.classList.remove("overflow-hidden-mobile");
          document.body.style.overflow = "";
          document.documentElement.style.overflow = "";
        }, 150);
      });
    }

    applyBtn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      var mobileForm = document.getElementById("FacetFiltersFormMobile");
      if (!mobileForm) return;

      var hiddenChecked = [];
      mobileForm.querySelectorAll(".facet-hidden-checkbox:checked").forEach(function (cb) {
        hiddenChecked.push(cb);
      });

      var merged = new URLSearchParams(window.location.search);

      FILTER_PARAMS.forEach(function(param) {
        merged.delete(param);
      });

      var seen = {};
      function addParam(k, v) {
        if ((k === "filter.v.price.gte" || k === "filter.v.price.lte") && !v) return;
        var u = k + "==" + v;
        if (seen[u]) return;
        seen[u] = true;
        merged.append(k, v);
      }

      mobileForm.querySelectorAll("input[type='checkbox']:checked").forEach(function (cb) {
        if (cb.classList.contains("swatch-input__input")) return;
        if (cb.classList.contains("facet-hidden-checkbox")) return;
        addParam(cb.name, cb.value);
      });

      hiddenChecked.forEach(function (cb) {
        addParam(cb.name, cb.value);
      });

      // var gte = mobileForm.querySelector("input[name='filter.v.price.gte']");
      // var lte = mobileForm.querySelector("input[name='filter.v.price.lte']");

      // var priceRangeEl = mobileForm.querySelector("price-range");
      // var minVal = priceRangeEl ? parseFloat(priceRangeEl.getAttribute("data-range-min") || 0) : 0;
      // var maxVal = priceRangeEl ? parseFloat(priceRangeEl.getAttribute("data-range-max") || 0) : 0;

      // var gte = mobileForm.querySelector("input[name='filter.v.price.gte']");
      // var lte = mobileForm.querySelector("input[name='filter.v.price.lte']");

      // var gteVal = gte ? parseFloat(gte.value || "") : NaN;
      // var lteVal = lte ? parseFloat(lte.value || "") : NaN;

      // if (!isNaN(gteVal) && gteVal > minVal) {
      //   addParam("filter.v.price.gte", String(gteVal));
      // }

      // if (!isNaN(lteVal) && lteVal < maxVal) {
      //   addParam("filter.v.price.lte", String(lteVal));
      // }

      var gte = mobileForm.querySelector("input[name='filter.v.price.gte']");
      var lte = mobileForm.querySelector("input[name='filter.v.price.lte']");

      var priceRangeEl = mobileForm.querySelector("price-range");
      var minVal = priceRangeEl ? parseFloat(priceRangeEl.getAttribute("data-range-min") || 0) : 0;
      var maxVal = priceRangeEl ? parseFloat(priceRangeEl.getAttribute("data-range-max") || 0) : 0;

      var gteVal = gte ? parseFloat(gte.value || "") : NaN;
      var lteVal = lte ? parseFloat(lte.value || "") : NaN;

      // 🔥 CLAMP VALUES (MAIN FIX)
      if (!isNaN(gteVal) && gteVal < minVal) {
        gteVal = minVal;
        if (gte) gte.value = minVal;
      }

      // 
      
      if (!isNaN(lteVal) && lteVal <= minVal) {
        lteVal = minVal + 1; // 🔥 main fix
        if (lte) lte.value = lteVal;
      }

      // APPLY PARAMS
      if (!isNaN(gteVal) && gteVal > minVal) {
        addParam("filter.v.price.gte", String(gteVal));
      }

      if (!isNaN(lteVal) && lteVal < maxVal) {
        addParam("filter.v.price.lte", String(lteVal));
      }

      if (window.FacetFiltersForm) {
        FacetFiltersForm.renderPage(merged.toString(), null, true);
      }

      setTimeout(function () {
        var menuDrawer = document.querySelector("menu-drawer.mobile-facets__wrapper");
        if (menuDrawer) {
          if (typeof menuDrawer.closeAnimation === "function") menuDrawer.closeAnimation();
          else if (typeof menuDrawer.close === "function") menuDrawer.close();
          else {
            var details = menuDrawer.querySelector("details[open]");
            if (details) details.removeAttribute("open");
          }
        }

        document.documentElement.classList.remove("overflow-hidden");
        document.body.classList.remove("overflow-hidden");
        document.body.classList.remove("overflow-hidden-mobile");
        document.body.style.overflow = "";
        document.documentElement.style.overflow = "";
      }, 150);
    });
  }

  function setupDesktopFilterListeners() {
    var form = document.getElementById("FacetFiltersForm");
    if (!form) return;
    form.addEventListener("change", function () { runDependencyUpdate(); });
  }

  // function setupSortDrawer() {
  //   var sortTrigger = document.querySelector(".mobile-sort-trigger");
  //   if (sortTrigger && !sortTrigger._sortSyncBound) {
  //     sortTrigger._sortSyncBound = true;
  //     sortTrigger.addEventListener("click", function () {
  //       var desktopSort = document.getElementById("SortBy");
  //       var radios = document.querySelectorAll(".mobile-sort-drawer input[type='radio'][name='sort_by']");
  //       if (desktopSort) {
  //         radios.forEach(function(radio) { radio.checked = (radio.value === desktopSort.value); });
  //       }
  //     });
  //   }
  //   var btn = document.querySelector(".mobile-sort-actions button[type='submit']");
  //   if (btn && !btn._sortBound) {
  //     btn._sortBound = true;
  //     btn.addEventListener("click", function () {
  //       var sel = document.querySelector(".mobile-sort-drawer select[name='sort_by']");
  //       var desktop = document.getElementById("SortBy");
  //       if (sel && desktop) {
  //         desktop.value = sel.value;
  //         desktop.dispatchEvent(new Event("change", { bubbles: true }));
  //       }
  //       var drawer = document.querySelector(".mobile-sort-drawer");
  //       if (drawer) drawer.classList.remove("active");
  //     });
  //   }
  // }

  function setupSortDrawer() {
    var sortTrigger = document.querySelector(".mobile-sort-trigger");
    var drawer = document.querySelector(".mobile-sort-drawer");
    var closeBtn = document.querySelector(".mobile-sort-close");
    var applyBtn = document.querySelector(".mobile-sort-actions button[type='submit']");
    var resetBtn = document.querySelector(".mobile-sort-actions button[type='reset']");

    function getDefaultSortValue() {
      var desktopSort = document.getElementById("SortBy");
      if (!desktopSort) return "";
      return desktopSort.getAttribute("data-default-sort-by") || "";
    }

    function getCurrentDesktopSortValue() {
      var desktopSort = document.getElementById("SortBy");
      if (!desktopSort) return "";
      return desktopSort.value || "";
    }

    function syncSortRadios(value) {
      var radios = document.querySelectorAll(".mobile-sort-drawer input[type='radio'][name='sort_by']");
      radios.forEach(function (radio) {
        radio.checked = (radio.value === value);
      });
    }

    function collectMobileFilterParams() {
      var params = new URLSearchParams();
      var mobileForm = document.getElementById("FacetFiltersFormMobile");
      if (!mobileForm) return params;

      var seen = {};

      function addParam(k, v) {
        if (!k) return;
        if ((k === "filter.v.price.gte" || k === "filter.v.price.lte") && !v) return;
        var key = k + "==" + v;
        if (seen[key]) return;
        seen[key] = true;
        params.append(k, v);
      }

      mobileForm.querySelectorAll("input[type='checkbox']:checked").forEach(function (cb) {
        if (cb.classList.contains("swatch-input__input")) return;
        if (cb.classList.contains("facet-hidden-checkbox")) return;
        addParam(cb.name, cb.value);
      });

      mobileForm.querySelectorAll(".facet-hidden-checkbox:checked").forEach(function (cb) {
        addParam(cb.name, cb.value);
      });

      var gte = mobileForm.querySelector("input[name='filter.v.price.gte']");
      var lte = mobileForm.querySelector("input[name='filter.v.price.lte']");

      var priceRangeEl = mobileForm.querySelector("price-range");
      var minVal = priceRangeEl ? parseFloat(priceRangeEl.getAttribute("data-range-min") || 0) : 0;
      var maxVal = priceRangeEl ? parseFloat(priceRangeEl.getAttribute("data-range-max") || 0) : 0;

      var gte = mobileForm.querySelector("input[name='filter.v.price.gte']");
      var lte = mobileForm.querySelector("input[name='filter.v.price.lte']");

      var gteVal = gte ? parseFloat(gte.value || "") : NaN;
      var lteVal = lte ? parseFloat(lte.value || "") : NaN;

      if (!isNaN(gteVal) && gteVal > minVal) {
        addParam("filter.v.price.gte", String(gteVal));
      }

      if (!isNaN(lteVal) && lteVal < maxVal) {
        addParam("filter.v.price.lte", String(lteVal));
      }

      return params;
    }

    if (sortTrigger && !sortTrigger._sortSyncBound) {
      sortTrigger._sortSyncBound = true;
      sortTrigger.addEventListener("click", function () {
        syncSortRadios(getCurrentDesktopSortValue());
        document.body.classList.add("overflow-hidden-mobile");
      });
    }

    if (closeBtn && !closeBtn._sortCloseBound) {
      closeBtn._sortCloseBound = true;
      closeBtn.addEventListener("click", function () {
        document.body.classList.remove("overflow-hidden-mobile");
      });
    }

    if (resetBtn && !resetBtn._sortResetBound) {
      resetBtn._sortResetBound = true;
      resetBtn.addEventListener("click", function (e) {
        e.preventDefault();
        syncSortRadios(getDefaultSortValue());
      });
    }

    if (applyBtn && !applyBtn._sortBound) {
      applyBtn._sortBound = true;
      applyBtn.addEventListener("click", function (e) {
        e.preventDefault();

        var merged = new URLSearchParams(window.location.search);
        var checkedRadio = document.querySelector(".mobile-sort-drawer input[type='radio'][name='sort_by']:checked");
        var selectedSort = checkedRadio ? checkedRadio.value : "";

        FILTER_PARAMS.forEach(function (param) {
          merged.delete(param);
        });

        // var filterParams = collectMobileFilterParams();
        // filterParams.forEach(function (value, key) {
        //   merged.append(key, value);
        // });

        // Use ONLY already applied filters from URL
        var currentParams = new URLSearchParams(window.location.search);

        currentParams.forEach(function (value, key) {
          if (FILTER_PARAMS.indexOf(key) !== -1) {
            merged.append(key, value);
          }
        });

        if (selectedSort) {
          merged.set("sort_by", selectedSort);
        } else {
          merged.delete("sort_by");
        }

        if (window.FacetFiltersForm) {
          FacetFiltersForm.renderPage(merged.toString(), null, true);
        }

        if (drawer) drawer.classList.remove("active");
        document.body.classList.remove("overflow-hidden-mobile");
      });
    }
  }

  function observeFilterRerender() {
    var observer = new MutationObserver(debounce(function () {
      removeDuplicateFilters();
      syncSwatchCheckboxes(document.getElementById("FacetFiltersForm"));
      syncSwatchCheckboxes(document.getElementById("FacetFiltersFormMobile"));
      setupMobileApplyButton();
      initAllPriceSliders();
    }, 200));
    var productGrid = document.getElementById("ProductGridContainer");
    if (productGrid) observer.observe(productGrid, { childList: true, subtree: true });

    var activeFacetsObserver = new MutationObserver(debounce(function () {
      updateMobileFilterBar();
    }, 100));
    [".active-facets-mobile", ".active-facets-desktop", ".active-facets"].forEach(function(sel) {
      var el = document.querySelector(sel);
      if (el) activeFacetsObserver.observe(el, { childList: true, subtree: true });
    });
  }

  function updateMobileFilterBar() {
    var filterSpan = document.querySelector(".mobile-filter-trigger .fiter-sort-head span");
    var sortSpan = document.querySelector(".mobile-sort-trigger .fiter-sort-head span");
    var urlParams = new URLSearchParams(window.location.search);

    if (filterSpan) {
      var count = 0;

      // FILTER_PARAMS.forEach(function(param) {
      //   if (RANGE_PARAMS.indexOf(param) !== -1) {
      //     var val = urlParams.get(param);
      //     if (val) count++;
      //   } else {
      //     count += urlParams.getAll(param).length;
      //   }
      // });

      var priceCounted = false;

      FILTER_PARAMS.forEach(function(param) {
        if (RANGE_PARAMS.indexOf(param) !== -1) {
          var val = urlParams.get(param);

          // ignore default min price
          if (param === "filter.v.price.gte") {
            var minVal = window._psMinPrice || 0;
            if (parseFloat(val) <= minVal) val = null;
          }

          // 🔥 count price as ONE filter only
          if (val && !priceCounted) {
            count++;
            priceCounted = true;
          }
        } else {
          count += urlParams.getAll(param).length;
        }
      });

      filterSpan.textContent = count > 0
        ? count + (count === 1 ? " Filter Applied" : " Filters Applied")
        : "No Filter Applied";
    }

    if (sortSpan) {
      var sortSelect = document.getElementById("SortBy");
      if (sortSelect) {
        sortSpan.textContent = sortSelect.options[sortSelect.selectedIndex].text;
      }
    }
  }

  function removeDuplicateFilters() {
    [
      document.getElementById("FacetFiltersForm"),
      document.getElementById("FacetFiltersFormMobile"),
      document.getElementById("FacetFiltersPillsForm"),
    ].forEach(function(form) {
      if (!form) return;
      var seenIds = {};
      form.querySelectorAll(".js-filter").forEach(function(el) {
        if (!el.id) return;
        if (seenIds[el.id]) { el.remove(); }
        else seenIds[el.id] = true;
      });
    });
  }

  // ──────────────────────────────────────────────
  // PRICE RANGE SLIDER
  // ──────────────────────────────────────────────
  function setupPriceSlider(container, isMobileSlider) {
    if (!container) return;
    var priceRangeEl = container.querySelector("price-range");
    if (!priceRangeEl || priceRangeEl._sliderInit) return;

    var gteInput = priceRangeEl.querySelector("input[name='filter.v.price.gte']");
    var lteInput = priceRangeEl.querySelector("input[name='filter.v.price.lte']");
    if (!gteInput || !lteInput) return;

    priceRangeEl._sliderInit = true;

    // Max value from data-range-max (injected via Liquid)
    var maxVal = parseFloat(priceRangeEl.getAttribute("data-range-max") || 0);
    var minVal = parseFloat(priceRangeEl.getAttribute("data-range-min") || 0);

    if (maxVal) window._psMaxPrice = maxVal;
    else if (window._psMaxPrice) maxVal = window._psMaxPrice;

    if (minVal || minVal === 0) window._psMinPrice = minVal;
    else if (window._psMinPrice || window._psMinPrice === 0) minVal = window._psMinPrice;

    if (!maxVal || maxVal < 100) maxVal = 100000;
    if (isNaN(minVal) || minVal < 0) minVal = 0;
    if (minVal >= maxVal) minVal = 0;

    // Sync with URL params
    var urlP = new URLSearchParams(window.location.search);
    var urlGte = parseFloat(urlP.get("filter.v.price.gte") || "");
    var urlLte = parseFloat(urlP.get("filter.v.price.lte") || "");
    var curMin = (!isNaN(urlGte) && urlGte >= minVal) ? urlGte : minVal;
    var curMax = (!isNaN(urlLte) && urlLte <= maxVal) ? urlLte : maxVal;

    // CSS once
    if (!document.getElementById("ps-css")) {
      var s = document.createElement("style");
      s.id = "ps-css";
      s.textContent = [
        ".ps-wrap{position:relative;height:20px;margin:10px 14px 15px;}",
        ".ps-track{position:absolute;top:9px;left:0;right:0;height:4px;background:#ddd;border-radius:2px;}",
        ".ps-fill{position:absolute;top:0;height:4px;background:#FAD830;border-radius:2px;}",
        ".ps-handle{position:absolute;top:50%;width:20px;height:20px;margin-top:-10px;margin-left:-10px;background:#FAD830;border:2px solid #fff;border-radius:50%;cursor:pointer;box-shadow:0 1px 5px rgba(0,0,0,0.3);z-index:1;}",
        "div.ps-handle{display:block!important;}",
        "div.ps-fill{display:block!important;}",
        "div.ps-track{display:block!important;}",
        "div.ps-wrap{display:block!important;}",
      ].join("");
      document.head.appendChild(s);
    }

    var wrap = document.createElement("div"); wrap.className = "ps-wrap";
    var track = document.createElement("div"); track.className = "ps-track";
    var fill = document.createElement("div"); fill.className = "ps-fill";
    track.appendChild(fill);
    var hMin = document.createElement("div"); hMin.className = "ps-handle ps-min";
    var hMax = document.createElement("div"); hMax.className = "ps-handle ps-max";
    wrap.appendChild(track); wrap.appendChild(hMin); wrap.appendChild(hMax);
    priceRangeEl.parentNode.insertBefore(wrap, priceRangeEl);
    wrap.dataset.max = maxVal;

    function toPct(v) { return Math.max(0, Math.min(100, ((v - minVal) / (maxVal - minVal)) * 100)); }
    function toVal(p) { return Math.round(minVal + (p / 100) * (maxVal - minVal)); }

    function draw() {
      var p1 = toPct(curMin), p2 = toPct(curMax);
      hMin.style.left = p1 + "%";
      hMax.style.left = p2 + "%";
      fill.style.left = p1 + "%";
      fill.style.width = (p2 - p1) + "%";
    }

    function setInputs() {
      curMin = Math.max(minVal, Math.min(curMin, curMax - 1));
      curMax = Math.min(maxVal, Math.max(curMax, curMin + 1));

      // gteInput.value = String(minVal);
      lteInput.value = curMax >= maxVal ? "" : String(curMax);

      gteInput.setAttribute("readonly", "readonly");
    }

    function triggerShopify() {
      if (isMobileSlider) return;
      // Trigger Shopify's FacetFiltersForm debounced handler
      lteInput.dispatchEvent(new Event("input", { bubbles: true }));
    }

    draw();
    setInputs();

    function attach(handle, isMin) {
      function onDown(e) {
        e.preventDefault();
        e.stopPropagation();
        var isTouch = e.type === "touchstart";
        function pos(ev) { return isTouch ? ev.touches[0].clientX : ev.clientX; }
        function onMove(ev) {
          ev.preventDefault();
          var rect = wrap.getBoundingClientRect();
          var pct = Math.max(0, Math.min(100, ((pos(ev) - rect.left) / rect.width) * 100));
          var v = toVal(pct);
          // var gap = Math.max(1, Math.round((maxVal - minVal) * 0.01));
          var gap = 1; // force 1 rupee difference
          if (isMin) curMin = Math.max(minVal, Math.min(v, curMax - gap));
          else curMax = Math.min(maxVal, Math.max(v, curMin + gap));
          draw();
          setInputs();
        }
        function onUp() {
          document.removeEventListener("mousemove", onMove);
          document.removeEventListener("mouseup", onUp);
          document.removeEventListener("touchmove", onMove);
          document.removeEventListener("touchend", onUp);
          triggerShopify();
        }
        document.addEventListener("mousemove", onMove);
        document.addEventListener("mouseup", onUp);
        document.addEventListener("touchmove", onMove, { passive: false });
        document.addEventListener("touchend", onUp);
      }
      handle.addEventListener("mousedown", onDown);
      handle.addEventListener("touchstart", onDown, { passive: false });
    }

    attach(hMin, true);
    attach(hMax, false);

    // Manual input → clamp → draw → trigger
    gteInput.addEventListener("change", function() {
      var v = parseFloat(gteInput.value);
      if (isNaN(v) || v < minVal) v = minVal;
      if (v >= maxVal) v = maxVal - 1;
      if (v >= curMax) v = curMax - 1;
      curMin = v;
      setInputs();
      draw();
      triggerShopify();
    });

    lteInput.addEventListener("change", function() {
      var v = parseFloat(lteInput.value);
      if (isNaN(v) || v > maxVal) v = maxVal;
      if (v <= minVal) v = minVal + 1;
      if (v <= curMin) v = curMin + 1;
      curMax = v;
      setInputs();
      draw();
      triggerShopify();
    });
  }

  function initAllPriceSliders() {
    setupPriceSlider(document.getElementById("FacetFiltersForm"), false);
    setupPriceSlider(document.getElementById("FacetFiltersFormMobile"), true);
    document.querySelectorAll("details").forEach(function(det) {
      if (det._psInit) return;
      var sum = det.querySelector("summary");
      if (!sum) return;
      if ((sum.textContent || "").toLowerCase().indexOf("price") === -1) return;
      det._psInit = true;
      var mob = !!det.closest("#FacetFiltersFormMobile");
      sum.addEventListener("click", function() {
        setTimeout(function() {
          var oldWrap = det.querySelector(".ps-wrap");
          if (oldWrap) { oldWrap.remove(); var pr = det.querySelector("price-range"); if (pr) pr._sliderInit = false; }
          setupPriceSlider(det, mob);
        }, 80);
      });
    });
  }

  function init() {
    removeDuplicateFilters();
    syncSwatchCheckboxes(document.getElementById("FacetFiltersForm"));
    syncSwatchCheckboxes(document.getElementById("FacetFiltersFormMobile"));
    interceptMobileAutoSubmit();
    setupMobileApplyButton();
    setupDesktopFilterListeners();
    setupSortDrawer();
    observeFilterRerender();
    applyFiltersFromURL();
    updateMobileFilterBar();
    initAllPriceSliders();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

// default best selling Reset
var checkedRadio = document.querySelector(".mobile-sort-drawer input[type='radio'][name='sort_by']:checked");
var desktop = document.getElementById("SortBy");
var sortVal = checkedRadio ? checkedRadio.value : "best-selling";
if (desktop) {
  desktop.value = sortVal;
  desktop.dispatchEvent(new Event("change", { bubbles: true }));
}

// Sort by highest rated
// 🔁 Detect sort change
document.addEventListener("change", function(e) {
  if (!e.target.closest("select[name='sort_by']")) return;

  if (e.target.value === "rating-desc") {
    localStorage.setItem("customSort", "rating-desc");

    // Delay ensures Shopify finishes rendering
    setTimeout(applyRatingSort, 500);
  } else {
    localStorage.removeItem("customSort");
  }
});

// 🔁 Run after ALL AJAX updates (final stable hook)
document.addEventListener("DOMContentLoaded", initCustomSort);
document.addEventListener("shopify:section:load", delayedSort);

function initCustomSort() {
  delayedSort();
}

// 🔥 KEY: multiple retries (guaranteed win)
function delayedSort() {
  if (localStorage.getItem("customSort") !== "rating-desc") return;

  // Run multiple times to override Shopify
  setTimeout(applyRatingSort, 300);
  setTimeout(applyRatingSort, 700);
  setTimeout(applyRatingSort, 1200);
}

// ⭐ Sorting logic
function applyRatingSort() {
  const container = document.querySelector("#product-grid");
  if (!container) return;

  let items = Array.from(container.querySelectorAll(".grid__item"));

  items.sort((a, b) => getRating(b) - getRating(a));

  let fragment = document.createDocumentFragment();
  items.forEach(el => fragment.appendChild(el));
  container.appendChild(fragment);
}

// 🔍 Rating extractor
function getRating(el) {
  let text = el.querySelector(".reviewRate")?.innerText || "";
  let val = parseFloat(text);
  return isNaN(val) ? 0 : val;
}